import React, { Component, useState } from "react";
import Chart from "react-apexcharts";
import { ResponsiveContainer } from "recharts";

function BarChartApex() {
  const [options, setoptions] = useState({
    chart: {
      id: "basic-bar",
    },
    xaxis: {
      categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999],
    },
  });
  const [series, setseries] = useState([
    {
      name: "series-1",
      data: [30, 40, 45, 50, 49, 60, 70, 91],
    },
  ]);
  return (
    <ResponsiveContainer width="100%" height={400}>
      <Chart options={options} series={series} type="bar" width="500" />
    </ResponsiveContainer>
  );
}

export default BarChartApex;
